/**
 * Classify admin_menu nodes for role button config shortcuts.
 * Aligns with docs/rbac-button-permission-optimization.md �3.
 */

export type MenuActionClass = 'page' | 'read' | 'create' | 'update' | 'remove' | 'export' | 'special';

/**
 * Map menuType + realm to an action class.
 *
 * @param realm admin_menu.realm
 * @param menuType admin_menu.menu_type (1/2 page, 3 button, 4 special)
 */
export function classifyMenuAction(realm: string | undefined, menuType: number | undefined): MenuActionClass {
    if (menuType === 1 || menuType === 2) {
        return 'page';
    }
    const r = (realm || '').toLowerCase();
    if (/export|excel-template|download|batchdownload/.test(r)) {
        return 'export';
    }
    if (/:delete|:remove|unbind|:cancel/.test(r) || /(^|:)(delete|remove)($|:)/.test(r)) {
        return 'remove';
    }
    if (/:create|:add/.test(r) || /(^|:)(create|add)($|:)/.test(r)) {
        return 'create';
    }
    if (/:update|save|change|reorder|confirm/.test(r)) {
        return 'update';
    }
    if (/query|get|list|page|tree|detail|selection|exists|suggest/.test(r)) {
        return 'read';
    }
    return 'special';
}

/** Chip letter for tree badge. */
export function actionClassLabel(c: MenuActionClass): string {
    switch (c) {
        case 'page':
            return 'P';
        case 'read':
            return 'R';
        case 'create':
            return 'C';
        case 'update':
            return 'U';
        case 'remove':
            return 'D';
        case 'export':
            return 'E';
        default:
            return 'S';
    }
}
